import { Component, Input, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BehaviorSubject, timer } from 'rxjs';
import { AppState } from '../../../core';

type AsyncOrSyncFunction = () => any | Promise<any>;

@Component({
  selector: 'modal-content',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements AfterViewInit {  
  
  onYes: AsyncOrSyncFunction = () => { console.log('yes clicked (no action)'); };
  onNo: AsyncOrSyncFunction = () => { console.log('no clicked (no action)'); }
  
  @Input() focusOnNo? : boolean = false;
  @Input() yesBtnText? = "Yes"
  @Input() noBtnText? = "No"
  @Input() title? = "Please Choose"
  @Input() question? = "Do you like green eggs and ham?"
  @Input() yesBtnClass = "btn btn-warning m-2"
  @Input() noBtnClass = "btn btn-primary m-2"
  
  @ViewChild('noBtn') noBtn : ElementRef
  @ViewChild('yesBtn') yesBtn : ElementRef

  yesProcessing = false;
  noProcessing = false;

  constructor(public bsModalRef: BsModalRef, public appState: AppState) {
  }

  ngAfterViewInit() {
    timer(0).subscribe( ms=> { 
        if( this.focusOnNo ) {
            this.noBtn?.nativeElement?.focus() 
        } else {
            this.yesBtn?.nativeElement?.focus() 
        }
    })
  }

  async onYesButtonClicked() {
    this.yesProcessing = true;
    try {
      await Promise.resolve(this.onYes());
      this.closeModal()
    } catch (error: any ) {
      this.appState.notifyError(error, this, 2);
    } finally {
      this.yesProcessing = false;
    }    
  }

  async onNoButtonClicked() {
    this.noProcessing = true;
    try {
      await Promise.resolve(this.onNo());
      this.closeModal()
    } catch (error: any ) {
      this.appState.notifyError(error, this, 2);
    } finally {
      this.noProcessing = false;
    }    
  }

  closeModal() {
    this.bsModalRef.hide()
  }
}